import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../elements/Loader'
import EmptyState from '../../../elements/EmptyState'
import ExaminationCenterCard from './ExaminationCenterCard'
import { clearDeletedExaminationCenter, clearUpdatedExaminationCenter, deleteExaminationCenter, fetchExaminationCenters } from '../../../../store/actions/examinationCentersActions'
import Pagination from '../../../elements/Pagination'
import { SET_SUCCESS } from '../../../../store/types'
import ModalDialog from '../../../layouts/ModalDialog'
import UpdateExaminationCenter from './UpdateExaminationCenter'

const ExaminationCenters = ({reload}) => {
  const dispatch = useDispatch()
  const examinationCentersSelector = useSelector(state => state.examinationCenters)
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);

  useEffect(() => {
    dispatch(fetchExaminationCenters('', page, perPage))
    
    if(examinationCentersSelector.deletedExaminationCenter !== null){
      dispatch(fetchExaminationCenters('', page, perPage))
      dispatch(clearDeletedExaminationCenter())
      dispatch({
        type: SET_SUCCESS,
        payload: 'examination center deleted!'
      })
    }
    
    if(examinationCentersSelector.updatedExaminationCenter !== null){
      setEditingExaminationCenter(false)
      dispatch(fetchExaminationCenters('', page, perPage))
      dispatch(clearUpdatedExaminationCenter())
      dispatch({
        type: SET_SUCCESS,
        payload: 'examination center updated successfully!'
      })
    }
    return () => {
      
    };
  }, [dispatch, page, perPage, examinationCentersSelector.deletedExaminationCenter, examinationCentersSelector.updatedExaminationCenter]);

  const deleteCenter = (index) => {
    if(window.confirm(`You are about to delete the examination center - ${examinationCentersSelector?.examinationCenters?.examinationCenters[index]?.name}. Please confirm if you are sure to proceed.`)){
      dispatch(deleteExaminationCenter(examinationCentersSelector?.examinationCenters?.examinationCenters[index]?._id))
    }
  }

  const [activeExaminationCenter, setActiveExaminationCenter] = useState(null);
  const [editingExaminationCenter, setEditingExaminationCenter] = useState(false);

  const openExaminationCenter = (center) => {
    setActiveExaminationCenter(center)
    setTimeout(() => {
      setEditingExaminationCenter(true)
    }, 50);
  }

  const closeExaminationCenter = () => {
    setEditingExaminationCenter(false)
    setTimeout(() => {
      setActiveExaminationCenter(null)
    }, 50);
  }

  return (
  <>
    <div className='w-full'>

      {examinationCentersSelector?.loadingExaminationCenters ? 
      
      <Loader /> : 

      <div className='w-full'>
      {
        examinationCentersSelector?.examinationCenters?.examinationCenters?.length > 0 ? 
        <>
          <div className='grid grid-cols-3 gap-5'>
            {examinationCentersSelector?.examinationCenters?.examinationCenters?.map((center, centerIndex)=>(<div key={centerIndex} className='w-full'>
              <ExaminationCenterCard 
              center={center} 
              deleteCenter={()=>{deleteCenter(centerIndex)}} 
              openCenter={()=>{openExaminationCenter(center)}} />
            </div>))}
          </div>
          <div className='mt-6'>
            <Pagination 
              pagination={{
                currentPage: page,
                perPage: perPage,
                totalItems: examinationCentersSelector?.examinationCenters?.total,
              }}
              changePage={(page)=>{setPage(page)}}
              updatePerPage={(perPage)=>{setPerPage(perPage)}}
            />
          </div>
        </>
        : 
          <EmptyState emptyStateText={`No examination centers created yet. Create one by clicking on 'Create new examination center' above`} />
      }
      </div>}
    </div>

    {activeExaminationCenter !== null && <ModalDialog
      shown={editingExaminationCenter} 
      closeFunction={()=>{setEditingExaminationCenter(false)}} 
      actionFunction={()=>{}} 
      actionFunctionLabel={`Update Examination Center`}
      dialogTitle='Create a new Examination Center'
      maxWidthClass='max-w-md'
      hideActions={true}
    >
      <UpdateExaminationCenter 
        center={activeExaminationCenter}
        description={`Update examination center`} 
        reload={()=>reload()}
        closeFunction={()=>{closeExaminationCenter()}} 
      />
    </ModalDialog>}
  </>
  )
}

export default ExaminationCenters